


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="align-items-center text-center mb-2">
                   <img :src="iconSubmisstion" class="img-full-width" style="width: 100px;"/>
              </div>
              <div class="align-items-center">
                <!-- <p class="mb-0 text-lg text-center text-black">
                  VAT Refund Application for Tourists is  </p>
                <p class="mb-0 text-md text-center text-black">
                  completed
                </p> -->

                 <p class="mb-0 text-lg text-center text-black">
                 e-VRT Request Submitted </p>
                

                  <p class="mb-0 text-sm text-center text-grey">
                  Receipt No. : {{ receiptStore.receiptsCode }}
                </p>

                  <p class="mb-0 text-sm text-center text-grey">
                 Store No. : {{ receiptStore.storeNumber }}
                </p>
              </div>
            </div>
            <div class="card-body ">
              
            <div class="row mb-5">
              <div class="col-md-6 mx-auto text-center">
                <GlobalButtonNext @click="handleClickCreateRequestForm">
                 New Request
                  <!-- <i class="fa fa-plus-circle" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i> -->
                </GlobalButtonNext>
              </div>
            </div>
            <hr class="hr-bar">
          <div class="col-12 ">
            <div class="row">
              <small class="text-important-h"> Important Note : </small>
              <p class="text-important-d"> 1. You will receive the ePP10 (Electronic VAT Refund Form) by email.</p>
              <p class="text-important-d"> 2. You can validate your VAT refund via Thailand VRT App or at kiosks, if your total refund amount does not exceed 30,000 Baht.</p>
            </div>
          </div>
       


             
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

     
    

</template>



<style>
  .text-important-h{
    font-size: 16px;
    font-weight: bold;
    color: rgba(38, 51, 77, 1);
  }

   .text-important-d{
    font-size: 14px;
    color: rgba(38, 51, 77, 1);
    margin-bottom: unset;
  }
  .hr-bar{
    color: rgba(38, 51, 77, 1);
  }
      
</style>



<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
//import { useRouter } from 'vue-router' 
//import { useReceiptStoreEvrt } from '@/store/useReceiptStoreEvrt';
import { useReceiptStoreEvrt } from '@/store/useReceiptStoreEvrt';
import iconSubmisstion from '@/assets/img/icons/pages/icon_submission.png';
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
//language // 
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
const receiptStore = useReceiptStoreEvrt();
//End language // 

//const emit = defineEmits(['prev']);

const handleClickCreateRequestForm = () => {
    window.location.reload();
};


const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;

});




</script>
